import router from '@/router';
export default {
  name: 'App',
  computed: {
    key() {
      return router.currentRoute.value.path + Math.random();
    }
  }
};